import { formatMessage } from "model/message";
import Debug from "debug";

// Helper function for creating generic actions
const createAction = (title, description, effect, notification) => {
  const debug = Debug(`action:${title}`);

  const message = (result) => formatMessage(description, result);

  const attempt = (context) => {
    const gain = typeof effect === "function" ? effect(context) : effect;
    const result = {
      success: true,
      gain: gain || {},
    };
    return result;
  };

  const executeSideEffects = (context, result) => {
    const { party, political, calendar } = context;
    const { history, traits, resources } = party;
    const { gain } = result;

    history.add({ action: title, result });
    traits.delta(gain.traits || {}, context);
    resources.delta(gain.resources || {}, context);
    calendar.delta(gain.calendar || {}, context);
    political.updateStatusMetrics(party.city, gain.status || {});

    return {
      message: message(result),
      notification: notification,
    };
  };

  const effectsAsTooltip = (effect) => {
    const { traits, resources } = effect;
    const tooltips = [];

    if (traits) {
      for (const key in traits) {
        tooltips.push([key, traits[key]]);
      }
    }
    if (resources) {
      for (const key in resources) {
        tooltips.push([key, resources[key]]);
      }
    }
    return tooltips.sort((a, b) => a[0].localeCompare(b[0]));
  };

  const ACTION = (context, onDone) => ({
    title: title,
    enabled: () => true,
    tooltips: effect ? effectsAsTooltip(effect) : [],
    execute: (localContext) => {
      const state = localContext || context;
      const result = attempt(state.party);
      const feedback = executeSideEffects(state, result);

      debug(feedback);
      if (onDone) onDone();

      return { result: { message: feedback.message }, ...feedback };
    },
  });

  return ACTION;
};

export default createAction;
